import { ApolloClient, ApolloLink, HttpLink, InMemoryCache } from '@apollo/client/core'
import type { App } from 'vue'
import { DefaultApolloClient } from '@vue/apollo-composable'
import { GraphQLWsLink } from '@apollo/client/link/subscriptions'
import { SetContextLink } from '@apollo/client/link/context'
import { api } from './feathers'
import { createClient } from 'graphql-ws'
import { getMainDefinition } from '@apollo/client/utilities'

const endpoint = import.meta.env.VITE_GRAPHQL_URL || 'localhost/v1/graphql'

// obtain auth JWT
async function getAuthToken() {
  const token = await api.authentication.getAccessToken()
  return token
    ? `Bearer ${token}`
    : ''
}

// Create the HTTP Link / WS Link / cache
const baseHttpLink = new HttpLink({ uri: `https://${endpoint}` })
const authLink = new SetContextLink(async (prevContext, _operation) => ({
  headers: {
    ...prevContext.headers, // preserve any existing headers
    Authorization: await getAuthToken(),
  },
}))
const httpLink = authLink.concat(baseHttpLink)

const wsLink = new GraphQLWsLink(
  createClient({
    url: `wss://${endpoint}`,
    connectionParams: async () => ({
      headers: { Authorization: await getAuthToken() },
    }),
    // auto-reconnect when token changes
    lazy: true,
  }),
)
const cache = new InMemoryCache()

// Split links based on operation type
const link = ApolloLink.split(
  ({ query }) => {
    const definition = getMainDefinition(query)
    return (
      definition.kind === 'OperationDefinition'
      && definition.operation === 'subscription'
    )
  },
  wsLink, // Use websockets for subscriptions
  httpLink, // Use rest for queries and mutations
)

// Initialize Apollo Client
export const apolloClient = new ApolloClient({ link, cache })

export const apolloPlugin = {
  install(app: App) {
    app.provide(DefaultApolloClient, apolloClient)
  },
}
